//
// Shop: Search
//

"use strict";

(function ($, waTheme) {

    var CheckMobile = (function ($) {

        CheckMobile = function (options) {
            var that = this;

            // DOM
            that.$window = $(window);

            // VARS
            that.reloading = false;

            // INIT
            // that.init();

            // EVENTS
            // that.bindEvents();
        };

        CheckMobile.prototype.init = function () {
            var that = this,
                is_mobile_max = MatchMedia("(max-width: 1280px)"),
                is_mobile = $.cookie("is_mobile");

            //
            if (that.reloading === false && is_mobile_max === true && is_mobile !== "true" && window.waTheme.is_mobile !== "true") {
                $.cookie("is_mobile", true);
                that.reloading = true;
                window.location.reload();
            }

            function MatchMedia(media_query) {
                var matchMedia = window.matchMedia;
                var is_supported = (typeof matchMedia === "function");

                if (is_supported && media_query) {
                    return matchMedia(media_query).matches;
                } else {
                    return false;
                }
            }
        };


        CheckMobile.prototype.bindEvents = function () {
            var that = this;

            //
        };

        return CheckMobile;

    })($);

    waTheme.init.shop.CheckMobile = CheckMobile;

    new window.waTheme.init.shop.CheckMobile({});

})(jQuery, window.waTheme);
